import React from 'react';
import styles from './Registration.module.css';

interface SubtitleTextProps {
  text?: string;
}

const defaultProps = {
  text: 'Save your progress in seconds',
};

const SubtitleText: React.FC<SubtitleTextProps> = ({ 
  text = defaultProps.text 
}) => {
  return (
    <div className={styles.subtitleText}>
      {text}
    </div>
  );
};

export default SubtitleText; 